import { getCasinoRoutes } from '~/components/router/casino-routes';
import type { Game } from '~/components/casino-shared/types';

const getGameUrls = ({ code, categoryCode = '' }: Partial<Pick<Game, 'code' | 'categoryCode'>>, license: string) => {
	const { ROUTE_CASINO_GAME, ROUTE_LIVE_CASINO_GAME } = getCasinoRoutes(license);
	const route = categoryCode === 'CASINO_LIVE_CASINO' ? ROUTE_LIVE_CASINO_GAME : ROUTE_CASINO_GAME;

	return {
		realModeUrl: `${route}/${code}/real`,
		funModeUrl: `${route}/${code}/fun`
	};
};

export default getGameUrls;
